import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { StudentsRemovalRequestsPendingDetailsResponse } from '../types';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { useParams } from 'react-router-dom';
import { getRequestPendingDetails } from '../api';
import { Card, Container } from 'reactstrap';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestsPendingDetailsResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestPendingDetails = useFetch;

function StudentsRemovalRequestPendingDetailsConsumer({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsPendingDetailsResponse;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        if (loading) {
          return (
            <Container fluid>
              <Card className="px-3 py-4">
                <Loading insideCard />
              </Card>
            </Container>
          );
        }

        if (!data) {
          return (
            <DisplayError
              textBody="Data no cargada"
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestPendingDetailsLoader({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsPendingDetailsResponse;
  }) => ReactElement;
}) {
  const { studyPlanEnrollmentId } = useParams<{
    studyPlanEnrollmentId: string;
  }>();

  const request = useCallback(async () => {
    return getRequestPendingDetails(+studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <StudentsRemovalRequestPendingDetailsConsumer>
        {({ data }) => children({ data })}
      </StudentsRemovalRequestPendingDetailsConsumer>
    </FetchProvider>
  );
}
